export enum MenuOption {
  Contact = "Contact",
  Password = "Password",
  Advanced = "Advanced",
  Users = "Users",
}
